module.exports = __webpack_public_path__ + "static/gwpark-339dd1dc4836cdeb12ac954d882b7138.png";